import { Injectable } from '@angular/core';
import { setAsideMenuOpenedState } from '@epicuro-next/state/user-ui-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';

import * as actions from '../actions';
import { selectIsOwner } from '../selectors';

@Injectable()
export class UserUiEffects {
  public collapseAsideMenu$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.setOpenedListSuccess),
      switchMap(({ list }) => {
        return this.store.pipe(select(selectIsOwner(list.id)));
      }),
      filter((isOwner) => !isOwner),
      map(() => setAsideMenuOpenedState({ opened: false })),
    ),
  );

  constructor(private actions$: Actions, private store: Store) {}
}
